export function slugify(text: string) {
	return text
		.toLowerCase()
		.trim()
		.replaceAll('æ', 'ae')
		.replaceAll('ø', 'o')
		.replaceAll('å', 'a')
		.normalize('NFKD')
		.replaceAll(/[\u0300-\u036f]/g, '')
		.replaceAll(/[^a-z0-9]+/g, '-')
		.replaceAll(/^-+|-+$/g, '')
}
